import * as types from "../constants";
import moment from 'moment';

const initialState = {
    date: moment().format("YYYY"),
    chart: {}
};

export default function reducer(state = initialState, actions) {
  const { type, payload } = actions;

  switch(type) {
    case types.CLEAR_POINSETTIA:
    case types.DELETE_CHART:
      return {
        ...state,
        chart: {}
      }
    case types.GET_CHART_TITLES:
      return {
        ...state,
        chartTitles: payload
      }
    case types.GET_YEARS:
      return {
        ...state,
        chartYears: payload
      }
    case types.ADD_CHEMICAL:
    case types.ADD_LEVEL:
    case types.ADD_MEASUREMENT:
    case types.SELECT_CHART:
    case types.CREATE_CHART:
    case types.EDIT_CHART:
    case types.COPY_CHART:
    case types.SAVE_TABLE:
      return {
        ...state,
        chart: payload,
      }
    case types.UPDATE_TABLE:
      return {
        ...state,
        chart: {
          ...state.chart,
          table: payload
        }
      }
    case types.CHANGE_DATE:
      return {
        ...state,
        date: payload
      }
    case types.POINSETTIA_CLEAN_UP:
      return initialState;
    default:
      return state;
  }
}
